// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__1KHcK","infoText":"PrivacyPolicy_infoText__ogAwS","infoTextLink":"PrivacyPolicy_infoTextLink__3AxyQ","privacy":"PrivacyPolicy_privacy__2mX9X"};